<template>
    <div id="FormPublish">
        <div class="settings-menu">
            <div
                class="menu-item"
                :class="{ active: activeItem === 0 }"
                @click="setActive(0)"
            >
                <i class="icon md-icon">link</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formPublish.shareFast") }}</div>
                    <div class="description">{{ $t("form.formPublish.shareFastDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item"
                :class="{ active: activeItem === 1 }"
                @click="setActive(1)"
            >
                <i class="icon md-icon">code</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formPublish.add") }}</div>
                    <div class="description">{{ $t("form.formPublish.addDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 2 }"
            >
                <i class="icon md-icon">group</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formPublish.assignForm") }}</div>
                    <div class="description">{{ $t("form.formPublish.assignFormDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 3 }"
            >
                <i class="icon md-icon">mail</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formPublish.emails") }}</div>
                    <div class="description">{{ $t("form.formPublish.emailsDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 4 }"
            >
                <i class="icon md-icon">storage</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formPublish.prefill") }}</div>
                    <div class="description">{{ $t("form.formPublish.prefillDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 5 }"
            >
                <i class="icon md-icon">picture_as_pdf</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formPublish.pdf") }}</div>
                    <div class="description">{{ $t("form.formPublish.pdfDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 6 }"
            >
                <i class="icon md-icon">layers</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formPublish.platforms") }}</div>
                    <div class="description">{{ $t("form.formPublish.platformsDesc") }}</div>
                </div>
            </div>
        </div>
        <div class="content">
            <ShareFast
                v-if="activeItem === 0"
                :formId="formId"
                :siteId="siteId"
            />
            <FormAdd
                v-if="activeItem === 1"
                :form-id="formId"
                :site-id="siteId"
            />
        </div>
    </div>
</template>
<script>
import ShareFast from "./ShareFast.vue";
import FormAdd from "./FormAdd.vue";

export default {
    name: "FormPublish",
    props: {
        formId: {
            type: String,
            required: true,
        },
        siteId: {
            type: String,
            required: true,
        },
    },
    components: {
        ShareFast,
        FormAdd,
    },
    data() {
        return {
            activeItem: 0,
        };
    },
    methods: {
        setActive(index) {
            this.activeItem = index;
        },
    },
};
</script>
<style lang="scss" scoped>
#FormPublish {
    display: flex;
    height: 100%;
    font-family: 'Roboto', sans-serif;

    .settings-menu {
        width: 300px;
        height: 100vh;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        overflow-y: auto;
        border-right: 1px solid #dcdcdc;
    }

    .menu-item {
        display: flex;
        align-items: center;
        background-color: #ffffff;
        padding: 1rem;
        border-radius: 0.5rem;
        cursor: pointer;
        transition: background-color 0.3s, transform 0.3s, box-shadow 0.3s;

        &.active {
            border: 2px solid #ff9830;
        }

        &:hover {
            background-color: #e0e0e0;
            transform: translateY(-2px);
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .icon {
            font-size: 1.5rem;
            margin-right: 1rem;
            color: #666;
            width: 24px;
            display: flex;
            justify-content: center;
        }

        .menu-text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;

            .title {
                font-weight: bold;
                font-size: 1rem;
                color: #333;
            }

            .description {
                font-size: 0.875rem;
                color: #666;
            }
        }

    }

    .disabled {
        display: none;
        opacity: 0.5;
        pointer-events: none;
    }


    .content {
        width: calc(100% - 300px);
        padding: 1rem;
    }
}
</style>
